module.exports = __webpack_public_path__ + "img/sld_scb_2_t1_red.7c9ef500.svg";